import styled from '@emotion/styled';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

type Length = string | number;

interface Props {
  width?: Length;
  height?: Length;
  size?: number;
  progress: number;
  label?: string | JSX.Element;
  variant?: 'static' | 'indeterminate' | 'determinate';
  className?: string;
}

type StyledComponentProps = {
  width: Length;
  height: Length;
};

const CircularWithLabel = ({
  width = '100%',
  height = 80,
  size = 48,
  progress,
  label = `${progress.toString()}%`,
  variant = 'determinate',
  className,
}: ClassAttributes<HTMLElement> & Props) => (
  <Root width={width} height={height} className={className}>
    <div>
      <CircularProgress variant={variant} size={size} value={progress} />
      <Label>
        <LabelText variant="caption">{label}</LabelText>
      </Label>
    </div>
  </Root>
);

const Root = styled('div')<StyledComponentProps>(({ width, height }) => ({
  ...flexibleLayoutContainer({
    direction: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  width,
  height,
}));

const Label = styled(Box)({
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const LabelText = styled(Typography)({
  color: 'white',
  fontWeight: 'bold',
});

export default CircularWithLabel;
